import React, { useState, useEffect } from 'react'
import { Header, Button } from 'semantic-ui-react'
import './BraveNewsletter.scss'
import PropTypes from 'prop-types'

const braveNewsletter = (props) => {
  /* const [ email, setEmail ] = useState('') */
  const [ emailError, setEmailError ] = useState(false)

  useEffect(() => {
    setEmailError(props.existError)
  }, [props.existError])

  /* const addEmail = () => {
    var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.
      [0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (re.test(String(email).toLowerCase())) {
      Promise.resolve(props.addEmail({ email: email }))
        .then(() => {
        setEmail('')
      })
    } else {
      setEmailError(true)
    }
  } */
  /* const changeEmail = (e) => {
    setEmailError(false)
    setEmail(e.target.value)
  } */
  return (
    <div className='Section'>
      <Header as='h2'>
      Stay connected, subscribe to our newsletter
      </Header>
      <div className='BraveNewsletter'>
        <Button
          className='NewsletterButton'
          style={{ marginBottom: emailError ? 5 : 0 }}
          onClick={
            () => window.open('https://eui.us6.list-manage.com/subscribe?u=fc99d6180b83f8f0dc8d2ee75&id=6b657a4b7e',
            '_blank')}
          >
          SUBSCRIBE
        </Button>
      </div>
    </div>)
}
braveNewsletter.propTypes = {
  existError: PropTypes.bool
}
export default braveNewsletter



// WEBPACK FOOTER //
// ./src/components/HomeComponent/BraveNewsletter/components/BraveNewsletter.js